module.exports = __webpack_public_path__ + "static/app-store-2fac09eddb61fefd268f63411d00737c.svg";